var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !!_vm.cards.length
    ? _c("div", { staticClass: "o-grid o-grid--center u-m-b7" }, [
        _c(
          "div",
          {
            staticClass:
              "c-post-click o-grid__item u-width-10/12 u-width-full@s",
          },
          [
            _c("h5", { staticClass: "u-m-b4 u-m-b3@s" }, [
              _vm._v("Related Content"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "c-cards__related_content",
                attrs: { "data-cy": "related-content" },
              },
              [
                _c(
                  "VueSlickCarousel",
                  _vm._b({}, "VueSlickCarousel", _vm.slickSettings, false),
                  _vm._l(_vm.cards, function (card) {
                    return _c("post-card-api", {
                      key: card.id,
                      attrs: { card: card },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _vm.$root.user !== false
          ? _c("a", {
              staticClass: "c-article__add",
              attrs: { href: "/post/create/" + _vm.$root.community.url },
            })
          : _c("a", {
              staticClass: "c-article__add",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.showMemberPanel.apply(null, arguments)
                },
              },
            }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }